var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nav',{staticClass:"cbr-tabs"},_vm._l((_setup.props.tabs),function(tab){return _c('div',{key:tab.id,staticClass:"cbr-tabs__tab",class:_setup.getTabClasses(tab),on:{"click":function($event){return _setup.onTabClick(tab)}}},[_vm._v(" "+_vm._s(tab.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }